import { CaseStudySliders } from '../case-study/case-study'
import { Slider5050 } from '../5050-squares/slider5050'

export function SliderInit() {
    const genericSliderEls = document.querySelectorAll('.js-slider')
    const caseStudyEls = document.querySelectorAll('.js-case-study-sliders')
    const slider5050Els = document.querySelectorAll('.js-5050-slider')
    const mobileSliderEls = document.querySelectorAll('.js-mobile-slider')
    const largeCtaBtnsEls = document.querySelectorAll('.js-large-cta-buttons-slider')
    const overviewSliderEls = document.querySelectorAll('.js-overview-slider')
    const rfCasestudySliderEls = document.querySelectorAll('.js-rf-casestudy-slider')
    const rfIndustrySliderEls = document.querySelectorAll('.js-rf-industry-slider')
    const rfTestimonialSliderEls = document.querySelectorAll('.js-rf-testimonial-slider')
    const rfProcessSliderEls = document.querySelectorAll('.js-rf-process-slider')

    if (
        genericSliderEls.length ||
        caseStudyEls.length ||
        slider5050Els.length ||
        mobileSliderEls.length ||
        largeCtaBtnsEls.length ||
        overviewSliderEls.length ||
        rfCasestudySliderEls.length ||
        rfIndustrySliderEls.length ||
        rfTestimonialSliderEls.length ||
        rfProcessSliderEls.length
    ) {
        import('./slider/index')
            .then((m) => m.Slider)
            .then((Slider) => {
                genericSlider(Slider, genericSliderEls)
                CaseStudySliders(Slider, caseStudyEls)
                Slider5050(Slider, slider5050Els)
                mobileSlider(Slider, mobileSliderEls)
                largeCtaBtnsSlider(Slider, largeCtaBtnsEls)
                overviewSlider(Slider, overviewSliderEls)
                rfCasestudySlider(Slider, rfCasestudySliderEls)
                rfIndustrySlider(Slider, rfIndustrySliderEls)
                rfTestimonialSlider(Slider, rfTestimonialSliderEls)
                rfProcessSlider(Slider, rfProcessSliderEls)
            })
            .catch((err) => console.error(err))
    }
}

function rfProcessSlider(Slider, els) {
    if (!els || !els.length) {
        return
    }

    const sliders = Array.from(els)

    sliders.forEach((el) => {
        Slider(el, {
            options: {
                arrows: false,
                horizontalSlide: true,
                horizontalSlideWrapper: '.js-rf-process-slider-track-wrap',
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: {
                    '768px': {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                        referenceArrows: true
                    }
                }
            }
        })
    })
}

function rfTestimonialSlider(Slider, els) {
    if (!els || !els.length) {
        return
    }

    const sliders = Array.from(els)

    sliders.forEach((el) => {
        Slider(el, {
            options: {
                arrows: true,
                referenceArrows: true,
                dots: true,
                referenceDotContainer: true,
                horizontalSlide: true
            }
        })
    })
}

function rfIndustrySlider(Slider, els) {
    if (!els || !els.length) {
        return
    }

    const sliders = Array.from(els)

    sliders.forEach((el) => {
        const backgroundSliderEl = el.querySelector('.js-rf-industry-slider-bg')
        const contentSliderEl = el.querySelector('.js-rf-industry-slider-slider')

        const backgroundSlider = Slider(backgroundSliderEl, {
            options: {
                fade: true,
                accessibility: false,
                swipe: false,
                slidesToShow: 1
            }
        })

        const slider = Slider(contentSliderEl, {
            options: {
                navFor: [backgroundSlider],
                horizontalSlide: true,
                horizontalSlideWrapper: '.js-rf-industry-slider-track-wrap',
                dots: true,
                referenceDotContainer: true,
                referenceDots: true,
                hiddenTransition: true,
                responsive: {
                    '768px': {
                        horizontalSlide: false,
                        classes: true,
                        hasNextClasses: true
                    }
                }
            }
        })

        slider.bus.events.slideChange.subscribe(() => {
            if (window.matchMedia('(max-width: 767px)').matches) {
                slider.elements.dots.forEach((el) => {
                    if (el.dataset.active === 'true') {
                        el.scrollIntoView({
                            behavior: 'smooth',
                            container: 'nearest',
                            block: 'start',
                            inline: 'start'
                        })
                    }
                })
            }
        })
    })
}

function rfCasestudySlider(Slider, els) {
    if (!els || !els.length) {
        return
    }

    const sliders = Array.from(els)

    sliders.forEach((el) => {
        const backgroundSliderEl = el.querySelector('.js-rf-casestudy-slider-bg')
        const contentSliderEl = el.querySelector('.js-rf-casestudy-slider-content')

        const backgroundSlider = Slider(backgroundSliderEl, {
            options: {
                fade: true,
                accessibility: false,
                swipe: false,
                slidesToShow: 1
            }
        })

        Slider(contentSliderEl, {
            options: {
                navFor: [backgroundSlider],
                arrows: true,
                referenceArrows: true,
                dots: true,
                referenceDotContainer: true,
                dotFormat: (x) => `<span class="u-visually-hidden">slide ${x}</span>`,
                horizontalSlide: true,
                slidesToShow: 1
            }
        })
    })
}

function overviewSlider(Slider, els) {
    if (!els || !els.length) {
        return
    }

    const sliders = Array.from(els)

    sliders.forEach((el) => {
        Slider(el, {
            options: {
                dots: false,
                arrows: false,
                autoplay: false,
                horizontalSlide: true,
                isInfinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                horizontalSlideWrapper: '.js-overview-slider-track-wrap',
                responsive: {
                    '768px': {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                        referenceArrows: true
                    }
                }
            }
        })
    })
}

function largeCtaBtnsSlider(Slider, els) {
    if (!els || !els.length) {
        return
    }

    const sliders = Array.from(els)

    sliders.forEach((el) => {
        Slider(el, {
            options: {
                dots: true,
                arrows: true,
                autoplay: false,
                horizontalSlide: true,
                isInfinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                referenceArrows: true,
                referenceDotContainer: true,
                dotFormat: (x) => `<span class="u-visually-hidden">slide ${x}</span>`,
                responsive: {
                    '768px': {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            }
        })
    })
}

function mobileSlider(Slider, els) {
    if (!els || !els.length) {
        return
    }

    const sliders = Array.from(els)

    sliders.forEach((el) => {
        Slider(el, {
            options: {
                dots: true,
                autoplay: true,
                isInfinite: true,
                horizontalSlide: true,
                dotFormat: (x) => `<span class="u-visually-hidden">slide ${x}</span>`,
                responsive: {
                    '768px': {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        isInfinite: false,
                        autoplay: false,
                        dots: false
                    }
                }
            }
        })
    })
}

function genericSlider(Slider, els) {
    if (!els || !els.length) {
        return
    }
    const sliders = Array.from(els)
    window.sliders = sliders.map((el) => {
        let {
            dots,
            slidesToShow,
            slidesToScroll,
            autoplay,
            arrows,
            isInfinite,
            mobileDisable,
            noResponsiveSlidesToShow
        } = el.dataset
        dots = dots === 'true'
        autoplay = autoplay === 'true'
        arrows = arrows === 'true'
        mobileDisable = mobileDisable === 'true'
        isInfinite = isInfinite !== 'false'
        noResponsiveSlidesToShow = noResponsiveSlidesToShow === 'true'
        slidesToShow = +slidesToShow || 1
        slidesToScroll = +slidesToScroll || 1
        let responsive = {}

        if (slidesToShow === 4 && !noResponsiveSlidesToShow) {
            slidesToShow = 2
            slidesToScroll = 2

            responsive = {
                '1024px': {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            }
        }

        if (slidesToShow === 3 && !noResponsiveSlidesToShow) {
            slidesToShow = 1
            slidesToScroll = 1

            responsive = {
                '768px': {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        }

        if (mobileDisable) {
            if (!responsive['768px']) {
                responsive['768px'] = {}
            }

            responsive['768px'].disabled = false
        }

        return Slider(el, {
            options: {
                slidesToShow,
                slidesToScroll,
                horizontalSlide: true,
                arrows,
                autoplay,
                referenceArrows: true,
                isInfinite,
                dots,
                referenceDotContainer: true,
                disabled: mobileDisable,
                dotFormat: (x) => `<span class="u-visually-hidden">slide ${x}</span>`,
                responsive
            }
        })
    })
}
